<template lang="pug">
  .voucher
    cp-field.voucher__code(
      label="Voucher"
      for="voucher__code"
      id="voucher__code"
      type="text"
      name="voucher__code"
      placeholder="Insira o número do voucher"
      :mask="['XXXXXXXXXX']"
      :value="code"
      :validation="checkCode"
      @change="setCode"
    )
</template>
<script>
import { mapState } from 'vuex'
import views from '@/mixins/views'
import { alphaNum, minLength, required } from 'vuelidate/lib/validators'
import { getVoucher } from '@/api/services'

import cpField from '@/components/molecules/Field.vue'

export default {
  name: 'Voucher',
  mixins: [views],
  props: {
    holderCPF: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      code: null,
      loading: false,
      status: false
    }
  },
  components: {
    cpField
  },
  computed: {
    ...mapState(['product']),
    checkCode () {
      const validations = [
        {
          type: 'success',
          valid: true
        },
        {
          type: 'error',
          msg: 'Voucher inválido',
          valid: false
        },
        {
          type: 'loading',
          msg: 'Verificando voucher...',
          valid: false
        }
      ]

      if (!this.$v.code.$invalid) return validations[0]
      if (this.loading) return validations[2]
      if (this.$v.code.$dirty && this.$v.code.$invalid) return validations[1]

      return {}
    }
  },
  methods: {
    setCode (value) {
      this.code = value
      this.setDirty(this.$v.code)

      if (this.status) {
        this.status = false
        this.outinput()
      }
    },
    validateCode (code) {
      this.loading = true

      return getVoucher({ code, cpf: this.holderCPF })
        .then((response) => {
          this.status = Boolean(response.data.active) || false
          return this.status
        })
        .catch((error) => {
          if (
            !error.response ||
            (error.response && error.response.status !== 400)
          ) {
            this.logError({
              tags: { app_errorZone: 'Voucher' },
              ctx: { label: '[Voucher] - validateVoucher' },
              error
            })
          }

          this.status = false
          return this.status
        })
        .finally(() => {
          this.loading = false
          this.outinput()
        })
    },
    outinput (status) {
      this.$emit('outinput', {
        ...(this.status &&
          {
            data: {
              code: this.code,
              cpf: this.holderCPF
            },
            installment: 1
          }
        ),
        isValid: status || this.status
      })
    },
    logError (args) {
      this.$sentry.logWithContext({
        level: 'error',
        tags: {
          app_product: this.product.alias,
          app_step: 'Pagamento',
          app_paymentMethod: 'voucher',
          ...args.tags
        },
        ctx: { ...args.ctx },
        error: args.error
      })
    }
  },
  beforeDestroy  () {
    this.$emit('outinput', { isValid: false })
  },
  validations: {
    code: {
      required,
      alphaNum,
      minLength: minLength(10),
      isInvalidCode (value) {
        return this.validateCode(value)
      }
    }
  }
}
</script>
